import { get } from 'lodash-es';
import { createSelector } from 'reselect';

import { emptyArray } from 'ui-components/default-props/empty';

export const selectRecommendations = (state) => get(state, 'recommendations', emptyArray);
export const selectRecommendationsIsLoading = (state) => get(state, 'isLoading', false);
export const selectRecommendationsHasLoaded = (state) => get(state, 'hasLoaded', false);

export const selectActiveRecommendations = createSelector(selectRecommendations, (recommendations) => {
  const active = recommendations.filter((r) => !r.isDismissed && !r.isActioned);
  return active.length === 0 ? emptyArray : active;
});

export const selectActiveRecommendationByType = (state, { recommendationType }) =>
  selectActiveRecommendations(state).find((r) => r.recommendationType === recommendationType);

export const selectRecommendationByType = (state, { recommendationType }) =>
  selectRecommendations(state).find((r) => r.recommendationType === recommendationType);
